const e={audio:["ContentSnippetAudioType"],documents:["ContentSnippetDocumentType"],video:["ContentSnippetEmbedType","ContentSnippetVideoType"]};export{e as TOOLBOX_MEDIA_TYPE_CONTENT_SNIPPET_TYPE_MAP};
//# sourceMappingURL=useToolBoxMedia.constants.js.map
